import { render, staticRenderFns } from "./RegionMap.vue?vue&type=template&id=53dd1298&scoped=true&"
import script from "./RegionMap.vue?vue&type=script&lang=js&"
export * from "./RegionMap.vue?vue&type=script&lang=js&"
import style0 from "./RegionMap.vue?vue&type=style&index=0&id=53dd1298&prod&lang=scss&scoped=true&"
import style1 from "./RegionMap.vue?vue&type=style&index=1&id=53dd1298&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53dd1298",
  null
  
)

export default component.exports